<template>
<div>
    <div class="row" v-for="(acti,idx) in bookingActivities" v-bind:key="idx">
        <div class="col-md-5">
            <v-select  type="text" name="activity_id" title="Prestation existante *" v-model="acti.id" :items="activities" @input="activitySelected(idx)" v-validate="'required'" data-vv-name="Activité"></v-select>
        </div>
        <div class="col-md-3">
            <v-input type="text" name="activityPrice" title="Prix HT Unitaire" v-model="acti.price" v-validate="'required'" data-vv-name="Prix"></v-input>
        </div>
        <div class="col-md-2">
            <v-input type="text" name="activityQty" title="Quantité" v-model="acti.qty" v-validate="'required|integer|min_value:0'" data-vv-name="Quantité"></v-input>
        </div>
        <button type="button" v-if="bookingActivities.length-1==idx && acti.id!=''" class="btn btn-primary" style="margin-top:30px" @click="newActivity()"><i class="fas fa-plus"></i></button>
        <button type="button" v-if="idx!=0||bookingActivities.length>1" class="btn btn-danger" style="margin-top:30px" @click="delActivity(idx)"><i class="fas fa-trash"></i></button>
    </div>
    <div class="alert alert-danger" v-show="ferrors.all().length>0">
        <ul>
            <li v-for="error in ferrors.all()" :key="error.id">{{ error }}</li>
        </ul>
    </div>
</div>
</template>
<script>
export default {
    name: 'calActivity',
    props: {
        activities: Array,
        value: Array
    },
    data() {
        return {
            bookingActivities:this.parseEntity(this.value)||[{id:"",qty:1,price:0}],
            errors: {},
        }
    },
    created(){
        this.$validator.reset();//to cancel model init validation
    },
    methods:{
        parseEntity(dbEntity){
            if(dbEntity){
                return dbEntity.map((acti)=>{return {id:acti.id,qty:acti.pivot.quantity,price:acti.pivot.price}})
            }
            return false
        },
        newActivity(){
            this.bookingActivities.push({id:"",qty:1,price:0})
        },
        delActivity(idx){
            this.bookingActivities.splice(idx,1)
        },
        activitySelected(idx){
            if(this.bookingActivities[idx].id!=""){
                this.bookingActivities[idx].price=this.activities.filter(acti=>acti.id==this.bookingActivities[idx].id)[0].price
            }
        },
        getActivities(){
            this.bookingActivities.forEach(acti => {
                if(!this.validate(acti)){
                    return false
                }
            });
            return this.bookingActivities.map(acti=>{return {id:acti.id,price:parseFloat(acti.price),qty:parseInt(acti.qty)}});
        },
        async validate(activity){
            let err = 0
            await this.$validator.validateAll().then((result) =>
            {
                console.log()
                if (!result) {
                    err=this.ferrors.all().length
                }
            });
            return err==0
            //return activity.id!="" && this.isNumber(activity.price) && this.isInt(activity.qty)
        },
        isNumber(val){
            return val && val.trim() && !isNaN(val)
        },
        isInt(val) {
            return !isNaN(val) && parseInt(Number(val)) == val && !isNaN(parseInt(val, 10));
        }
    }
}
</script>